import { Component, Injectable } from '@angular/core';

@Component({
  selector: 'app-invalid',
  templateUrl: './invalid-application.component.html',
  styleUrls: ['./invalid-application.component.scss'],
  standalone: false
})
@Injectable()
export class InvalidApplicationComponent {}
